module.exports = __webpack_public_path__ + "img/won-data-amount-icon.77a2c3b5.png";